import { render, staticRenderFns } from "./DetalhesPrestacaoContas.vue?vue&type=template&id=a0828680&scoped=true"
import script from "./DetalhesPrestacaoContas.vue?vue&type=script&lang=js"
export * from "./DetalhesPrestacaoContas.vue?vue&type=script&lang=js"
import style0 from "./DetalhesPrestacaoContas.vue?vue&type=style&index=0&id=a0828680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0828680",
  null
  
)

export default component.exports